import cn from 'classnames';
import React from 'react';
import styles from './custom-switch.module.scss';

function CustomSwitch({
  id,
  checked,
  onChange,
  label,
  labelPosition = 'right',
  disabled = false,
  ...props
}) {
  return (
    <label
      htmlFor={id}
      className={cn(styles.customSwitch, {
        [styles.disabled]: disabled,
      })}
    >
      {label && labelPosition === 'left' && (
        <span className={styles.label}>{label}</span>
      )}
      <input
        id={id}
        type="checkbox"
        role="switch"
        className={styles.input}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        aria-checked={checked}
        {...props}
      />
      <span className={styles.slider} />
      {label && labelPosition === 'right' && (
        <span className={styles.label}>{label}</span>
      )}
    </label>
  );
}

export default CustomSwitch;
